import { css } from '@emotion/react';

export const checkboxGroupLayout = css`
  > *:nth-of-type(2) {
    display: flex;
  }
`;
